module.exports = __webpack_public_path__ + "img/锂电行业结构示意图.36c7ae8d.jpg";